<template>
  <div>
    <el-dialog :close-on-click-modal="false" :visible.sync="auditDialogVisible" v-loading="tableLoading" width="900px">
      <div slot="title" class="dialog-title">
        审核
      </div>
      <div class="dialogCon">
        <div class="cols" style="display:flex">
          <div>
            <span class="audit-title">审核结果：</span>
            <el-radio v-model="approvalState" label="Y">合格</el-radio>
            <el-radio v-model="approvalState" label="N">不合格</el-radio>
          </div>
        </div>
        <!-- <div class="cols">
          <el-input v-model="revokeCause" placeholder="请填写撤回的原因"></el-input>
        </div> -->
        <div v-if="approvalState==='N'">
          <span class="audit-title">审核原因：</span>
        <div class="dialogCon-checkbox">
          <el-checkbox-group v-model="checkedIssues">
            <!-- <el-checkbox v-for="(item, index) in reasonList" :key="index" :label="item" class="checkbox-hover">{{
              item.evaluationRuleDesc
            }}</el-checkbox> -->
            <el-form>
              <el-form-item>
                <div  class="dialogCon-checkbox-type">
                  <!-- <div style="height: 20px">{{ item.text }}</div> -->
                  <div class="type-check-list">
                    <div class="type-check-item" v-for="(item, idx) in getCodeListByKey('客户建档审核不合格原因')" >
                      <el-checkbox :label="item.text">{{ item.text }}</el-checkbox>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </el-form>
          </el-checkbox-group>
        </div>
        </div>
        
        <!-- 原因说明 -->
        <div class="dialogCon-describe">
          <p>
            <span slot="label" style="color: red" v-if="approvalState==='N'">*</span>
            <span>原因说明</span>
          </p>
          <!-- :disabled="disabledInput" -->
          <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            v-model="issuesDesc"
            
            @input="checkedIssuesTextEvent"
            maxlength="200"
            show-word-limit
            placeholder="请输入内容"
            clearable
          ></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="auditDialogVisible = false">取 消</el-button>
        <el-button size="small" type="info" @click="toAuditSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      auditDialogVisible: false,
      title: '',
      // type: '',
      // reviewList: [],
      approvalState:'',//审核结果
      checkedIssues: [], //选中的原因
      issuesDesc: '', //原因说明
      disabledInput: false, // 禁止输入
      approveGuidList:[],
      tableLoading:false
    };
  },
  filters: {
    approveType(val) {
      let objStr = {
        Y: '合格',
        N: '不合格',
        P: '部分合格',
      };
      return objStr[val] || '-';
    },
    tenantApproveType(val) {
      let objStr = {
        Y: '满意',
        N: '不满意',
      };
      return objStr[val] || '-';
    },
  },
  watch: {
    dialogVisible(val) {
      // 监听原因说明弹框
      if (val) {
        this.issuesDesc = '';
      }
    },
    approvalState(val) {
      // 监听审核状态
      this.disabledInput = false;
      this.issuesDesc = '';
      this.checkedIssues = [];
      if (val=='N') {
        this.disabledInput = true;
      }
    },
    checkedIssues: {
      handler(newVal, oldVal) {
        console.log('kk',newVal, oldVal);
        
        if (newVal && newVal.length) {
          this.disabledInput = false;
        } else if(this.approvalState!='Y'){
          this.disabledInput = true;
        }
        this.checkedIssuesChange(newVal, oldVal);
        if (this.approvalState === 'Y' && newVal.length === 0) {
          this.issuesDesc = '';
        }
      },
    },
  },
  created() {
    this.$root.$on('auditDialog', (data) => {
      console.log('data',data);
      
      this.auditDialogVisible = data.auditDialogVisible;
      this.title = data.title;
      // this.type = data.type;
      this.approveGuidList = data.approveGuidList;
    });
    //  this.$root.$on('viewGoodsFile', data => {
    //   this.openReviewRecords = data.openReviewRecords;
    //   this.title = data.title;
    //   this.type = data.type;
    //   this.reviewList = data.reviewList;
    //   // this.reviewList = []
    //   // this.$nextTick(()=>{
    //   //   this.reviewList = data.reviewList;
    //   // })
    // });
  },
  beforeDestroy() {
    this.$root.$off('viewGoodsFile')
    this.$root.$off('viewReviewRecords')
  },
  methods: {
     // 拍照要求勾选事件
     checkedIssuesChange(newVal, oldVal) {
      if (newVal.length && newVal.length > oldVal.length) {
        let arr = [];
        if (newVal && Array.isArray(newVal)) {
          let len = newVal.length;
          let item = newVal[len - 1];
          arr.push(`${len}、${item}`);
        }
        this.issuesDesc = this.issuesDesc + arr.join('\n') + '\n';
        this.issuesDesc = this.issuesDesc.slice(0, 200)
      }
    },
    // 原因说明输入事件
    checkedIssuesTextEvent(val) {
      if (!/^[a-zA-Z0-9_-、%()（），.。,\-\u4e00-\u9fa5\n]+$/.test(val) && val) {
        // this.disabledInput = true;
        this.openMessageBox();
      } else {
        // this.disabledInput = false;
      }
    },
    openMessageBox() {
      this.$NewMessage.warning({
        message: '仅可输入汉字、英文、数字、下划线【_】、减号【-】',
      });
    },
     //提交审核
     toAuditSubmit() {
      if (!this.approvalState) {
        this.$message.error('审核结果不能为空');
        return;
      }
      if (
        this.approvalState == 'N' &&
        !this.issuesDesc
      ) {
        this.$message.error('请填写原因说明');
        return;
      }
      console.log('777',this.approvalState,this.checkedIssues,this.issuesDesc);
      this.toAuditRequire();
      
    },
    toAuditRequire() {
      let userInfo = JSON.parse(localStorage.userInfo);
      let query = {
        customerPlfApproveGuidList:this.approveGuidList,
        approveStaffGuid: userInfo.staffGuid,
        approveStaffName: userInfo.staffName,
        approveState: this.approvalState,
        approveSuggest: this.issuesDesc, // 原因说明,
      };
      this.tableLoading = true;
      this.api
        .postJson(`/${serverConfig.msCustomerService}/plf-base-approve/submit-approve`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.tableLoading = false;
            // this.$message.success(this.messageSuccessTip);
            this.$message.success('审核成功');
            this.auditDialogVisible = false;
            this.$emit('closeAudit', this.approvalState)
            // this.checkedIssues = [];
            // if (this.taskDataList.length == this.bizItems.length && this.page.pageIndex > 1) {
            //   this.page.pageIndex = this.page.pageIndex - 1;
            // }
            // this.page.pageIndex = 1;
            // this.getData(true);
          } else {
            this.$message.error(`${this.messageErrorTip}${res.msg ? `:${res.msg}` : ''}`);
            this.tableLoading = false;
          }
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    closedBox() {
      this.reviewList = []
      this.openReviewRecords = false
    }

    // getApproveType(val) {
    //   let objStr = {
    //     Y: 'success',
    //     N: 'danger',
    //     // P: 'warning',
    //   };
    //   return objStr[val] || '-';
    // },
    // issusesFormat(list) {
    //   if ((list && list.length == 0) || !list) {
    //     return '-';
    //   }
    //   let resultArr = [];
    //   list.forEach((oneData, key) => {
    //     resultArr.push(key + 1 + '. ' + oneData.evaluationRuleDesc);
    //   });
    //   return resultArr.join('\n');
    // },
    // viewPicDetail(url) {
    //   if (url) window.open(url)
    // },
   
  },
};
</script>

<style lang="less" scoped>
.el-timeline-item {
  // padding-bottom: 0px;
}
/deep/.el-dialog__header {
  border-bottom: 1px solid #d9d9d9;
}
// .dialog-title {
//   text-align: left;
//   width: 240px;
//   height: 27px;
//   font-family: PingFang SC;
//   font-size: 18px;
//   color: #212121;
//   letter-spacing: 0;
//   line-height: 27px;
//   font-weight: 400;
// }
// .operte-btns {
//   text-align: right;
//   border-top: 1px solid #d9d9d9;
//   background: #fff;
//   margin-top: 4px;
//   display: flex;
//   justify-content: center;
//   padding: 15px 0;
// }
// .operte-btns .btn {
//   padding: 5px 18px;
//   border: 1px solid rgba(217, 217, 217, 1);
//   border-radius: 2px;
//   cursor: pointer;
//   margin-right: 10px;
// }
// .approve-history {
//   max-height: 500px;
//   overflow-y: auto;
//   padding-right: 20px;
//   .reason-text {
//     color: #7f7f7f;
//   }
// }
// .good-file {
//   max-height: 700px;
//   overflow-y: auto;
//   padding-right: 20px;
// }
  .dialog-title {
    text-align: left;
    width: 240px;
    height: 27px;
    font-family: PingFang SC;
    font-size: 18px;
    color: #212121;
    letter-spacing: 0;
    line-height: 27px;
    font-weight: 400;
  }
  .audit-title{
    text-align: left;
    width: 240px;
    height: 27px;
    font-family: PingFang SC;
    font-size: 14px;
    color: #212121;
    letter-spacing: 0;
    line-height: 27px;
    font-weight: 600;
  }
  .dialogCon {
    border-top: 1px solid #dcdee0;
    text-align: left;
    padding: 10px 20px;
    .label{
      margin-right: 10px;
      line-height: 40px
    }
  }
  .moreInfoCon {
    .label{
      width:135px
    }
  }
  .dialogCon /deep/ .el-checkbox {
    padding: 0 14px;
    width: 40%;
    // height: 40px;
    // line-height: 40px;
    .el-checkbox__label {
      color: #212121;
    }
  }
  .dialogCon .dialogCon-checkbox /deep/ .el-checkbox-group {
    display: block;
  }
  .dialogCon .dialogCon-checkbox {
    max-height: 400px;
    overflow-y: auto;
    /deep/.el-form-item__content {
      line-height: 25px;
    }
    /deep/.el-form-item {
      margin-bottom: 0px;
    }
  }
  .dialogCon-checkbox-type {
    width: 100%;
  }
  .type-check-list {
    margin-top: 4px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }
  .type-check-item {
    width: 50%;
  }
</style>
